const ACCORDION_ID = 'collapse05';
const BREAKPOINT_SM = 576;

function handleAccordionState(
    accordionElement: HTMLElement,
    accordionButton: Element
): void {
    if (window.innerWidth < BREAKPOINT_SM) {
        // Mobile (< 576px): chiudi l'accordion
        accordionElement.classList.remove('show');
        accordionButton.classList.add('collapsed');
        accordionButton.setAttribute('aria-expanded', 'false');
    } else {
        // Desktop (>= 576px): apri l'accordion
        accordionElement.classList.add('show');
        accordionButton.classList.remove('collapsed');
        accordionButton.setAttribute('aria-expanded', 'true');
    }
}

export function initAccordionDatiCatastali(): void {
    const accordionElement = document.getElementById(ACCORDION_ID);
    if (!accordionElement) return;

    const accordionButton = document.querySelector(`[data-bs-target="#${ACCORDION_ID}"]`);
    if (!accordionButton) return;

    // Applica lo stato iniziale
    handleAccordionState(accordionElement, accordionButton);

    // Listener per il resize (con debounce)
    let resizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => handleAccordionState(accordionElement, accordionButton), 150);
    });
}
